export default class MainMenu {
    /**
     * @type {string}
     * @readonly
     */
    mainMenuName = 'menu--main';
    /**
     * @type {HTMLDivElement}
     * @readonly
     */
    elMainMenu = document.querySelector(`.${this.mainMenuName}`);
    /**
     * @type {NodeListOf<HTMLLIElement>}
     * @readonly
     */
    elDropdownItems = document.querySelectorAll('.menu-item--expanded');
    /**
     * @type {HTMLButtonElement}
     * @readonly
     */
    elHamburgerButton = document.querySelector('.js-hamburger-button');
    /**
     * @type {string}
     * @readonly
     */
    menuItemOpenName = 'js-open-dropdown';
    /**
     * @type {string}
     * @readonly
     */
    menuItemMouseEnteredName = 'js-mouse-entered';
    /**
     * @type {string}
     * @readonly
     */
    menuItemWaitingToCloseName = 'js-waiting-to-close';
    /**
     * Number of milliseconds
     * @type {number}
     * @readonly
     */
    hoverCloseTimeout = 500;
    /**
     * Open dropdown on hover
     *
     * @type {boolean}
     * @readonly
     */
    openOnHover = true;

    constructor() {
        if (this.elMainMenu === null) {
            return;
        }

        /** Toggle menu on clicking the hamburger button */
        this.elHamburgerButton?.addEventListener('click', () => {
            this.elMainMenu.classList?.toggle('js-show-menu');
        });

        if (this.elDropdownItems.length === 0) {
            return;
        }

        this.elDropdownItems?.forEach((element) => {
            /** @type {HTMLAnchorElement} */
            const elLink = element.querySelector(':scope > a');

            /** Open dropdown on clicking the link */
            elLink?.addEventListener('click', (event) => {
                /** @type {boolean} */
                const toOpen = !element.classList.contains(
                    this.menuItemOpenName,
                );

                event.stopPropagation();
                event.preventDefault();

                if (element.classList.contains(this.menuItemMouseEnteredName)) {
                    element.classList.remove(this.menuItemMouseEnteredName);
                    element.classList.add('js-menu-item-already-opened');
                    element.addEventListener('animationend', () => {
                        element.classList.remove('js-menu-item-already-opened');
                    });
                    this.toggleDropdownMenu(element, true);
                    return;
                }

                this.toggleDropdownMenu(element, toOpen);
            });

            if (this.openOnHover) {
                /** Open dropdown on mouseenter */
                element.addEventListener('mouseenter', () => {
                    /** @type {boolean} */
                    const toOpen = !element.classList.contains(
                        this.menuItemOpenName,
                    );

                    element.classList.remove(this.menuItemWaitingToCloseName);

                    if (element.classList.contains(this.menuItemOpenName)) {
                        return;
                    }

                    element.classList.add(this.menuItemMouseEnteredName);

                    if (toOpen) {
                        this.toggleDropdownMenu(element, true);
                    }
                });

                /** Close dropdown on mouseleave if the menu is opened by hover */
                element.addEventListener('mouseleave', () => {
                    if (
                        !element.classList.contains(
                            this.menuItemMouseEnteredName,
                        )
                    ) {
                        return;
                    }

                    element.classList.add(this.menuItemWaitingToCloseName);

                    setTimeout(() => {
                        if (
                            !element.classList.contains(
                                this.menuItemWaitingToCloseName,
                            )
                        ) {
                            return;
                        }

                        element.classList.remove(
                            this.menuItemWaitingToCloseName,
                        );
                        element.classList.remove(this.menuItemMouseEnteredName);
                        this.toggleDropdownMenu(element, false);
                    }, this.hoverCloseTimeout);
                });
            }
        });

        /** Close all dropdowns when clicking outside */
        document.documentElement.addEventListener('click', (event) => {
            if (event.target.closest(`.${this.mainMenuName}`) === null) {
                this.closeAllDropdowns();
            }
        });

        /** Close all dropdowns when pressing escape */
        document.documentElement.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                this.closeAllDropdowns();
            }
        });
    }

    /**
     * Toggle the dropdown menu
     *
     * @param element {HTMLLIElement}
     * @param toOpen {boolean}
     * @returns {void}
     */
    toggleDropdownMenu(element, toOpen) {
        element.classList.toggle(this.menuItemOpenName, toOpen);
        element.setAttribute('aria-expanded', toOpen.toString());
    }

    /**
     * Close all dropdown menus
     *
     * @returns {void}
     */
    closeAllDropdowns() {
        this.elDropdownItems?.forEach((element) => {
            this.toggleDropdownMenu(element, false);
        });
    }
}
